module.exports = __webpack_public_path__ + "static/sac1-8902bb3c0b3b848affd434d823295fed.jpg";